export default {
  'global': {
    'send': 'Trimiteți',
    'save': 'Salvați',
    'confirm': 'Confirmați',
    'cancel': 'Anulați',
    'brand': 'HeiGIT - Universitatea din Heidelberg',
    'close': 'Închideți',
    'closeAndDoNotShowAgain': 'Închideți și nu afișați din nou',
    'select': 'Selectați',
    'yes': 'Da',
    'no': 'Nu',
    'and': 'și',
    'noAndDonAskAgain': 'NU (nu întrebați din nou)',
    'ok': 'OK',
    'polygon': 'poligon',
    'developedByIntro': 'Servicii dezvoltate de',
    'developedBy': 'HeiGIT gGmbH',
    'duration': 'Durată',
    'distance': 'Distanță',
    'elevation': 'Elevație',
    'profile': 'Profil',
    'options': 'Opțiuni',
    'parameters': 'Parametrii',
    'custom': 'Personalizat',
    'customOverlayer': 'Strat de acoperire personalizat',
    'rawRouting': 'Traseu brut',
    'months': {
      'january': 'Ianuarie',
      'february': 'Februarie',
      'march': 'Martie',
      'april': 'Aprilie',
      'may': 'Mai',
      'june': 'Iunie',
      'july': 'Iulie',
      'august': 'August',
      'september': 'Septembrie',
      'october': 'Octombrie',
      'november': 'Noiembrie',
      'december': 'Decembrie'
    },
    'monthsShort': {
      'january': 'Ian',
      'february': 'Feb',
      'march': 'Mar',
      'april': 'Apr',
      'may': 'Mai',
      'june': 'Iun',
      'july': 'Iul',
      'august': 'Aug',
      'september': 'Sep',
      'october': 'Oct',
      'november': 'Nov',
      'december': 'Dec'
    },
    'units': {
      'm': 'm',
      'minutes': 'minute',
      'km': 'km(s)',
      'mi': 'mi(s)',
      'seconds': 'secunde',
      's': 's',
      'hours': 'oră(e)',
      'days': 'd',
      'h': 'h',
      'min': 'min',
      'meters': 'metri',
      'lat': 'latitudine',
      'lng': 'longitudine',
      'tones': 'tonuri',
      't': 't',
      'kmh': 'km/h'
    },
    'layers': {
      'region': 'Regiune',
      'macrocounty': 'Macro județ',
      'country': 'Țara',
      'county': 'Județ',
      'macroregion': 'Macro regiune',
      'neighbourhood': 'Vecinătate',
      'locality': 'Localitate',
      'borough': 'Orășel',
      'localadmin': 'Administrator local',
      'address': 'Adresă',
      'notAvailable': 'Nu este disponibil',
      'undefined': 'Nedefinit',
      'street': 'Stradă',
      'venue': 'Locația',
      'rawCoordinate': 'Coordonate brute lng,lat',
      'postalcode': 'Cod poștal',
      'ocean': 'Oceanul'
    },
    'population': 'Populația',
    'roadaccessrestrictions': 'Restricții de acces la drumuri',
    'green': 'Verde',
    'noise': 'Zgomot',
    'steepness': 'Abrupt',
    'surface': 'Suprafață',
    'waytype': 'Tipul de căi',
    'suitability': 'Adecvare',
    'waycategory': 'Categoria Calea',
    'tollways': 'Autostrăzi cu taxă',
    'traildifficulty': 'Dificultatea traseului',
    'osmid': 'OSM ID',
    'countryinfo': 'Informații despre țară'
  }
}
